// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html {\n  height: 100%;\n}\nbody {\n  height: 100%;\n  overflow-x: auto;\n}\n#app {\n  text-align: center;\n  color: #2c3e50;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  min-width: 1440px;\n}\n.patentStyle {\n  min-width: 134px;\n  width: auto !important;\n}", ""]);
// Exports
module.exports = exports;
